(function () {
  var BGN_RATE = 1.95583;
  var renderTimer = null;
  var suppressObserver = false;

  function getActiveLocale() {
    var lang = (document.documentElement.lang || 'bg').toLowerCase();
    return lang.indexOf('nl') === 0 ? 'nl' : 'bg';
  }

  function isBulgarian() {
    return getActiveLocale() === 'bg';
  }

  function parseEuroAmount(value) {
    var match;

    value = (value || '').replace(/\s+/g, ' ');
    match = value.match(/€\s*([0-9]+(?:[.,][0-9]{1,2})?)/) || value.match(/([0-9]+(?:[.,][0-9]{1,2})?)\s*€/);
    if (!match) return null;

    return parseFloat(match[1].replace(',', '.'));
  }

  function formatLev(amount) {
    return amount.toFixed(2).replace('.', ',') + ' лв';
  }

  function amountFromAttributes(element) {
    var attrs = [
      'data-offer-price',
      'data-price',
      'data-product-price',
      'data-variant-price',
      'data-current-price',
      'data-offer-total',
      'data-total-price'
    ];
    var i;
    var value;
    var amount;

    if (!element) return null;

    for (i = 0; i < attrs.length; i += 1) {
      value = element.getAttribute(attrs[i]);
      amount = parseEuroAmount(value);
      if (amount) return amount;
    }

    return null;
  }

  function selectedOfferAmount(scope) {
    var selected;
    var amount;
    var selector = [
      'input[type="radio"]:checked',
      'input[type="checkbox"]:checked',
      '[aria-checked="true"]',
      '.is-selected',
      '.selected',
      '[data-selected="true"]'
    ].join(',');

    if (!scope) return null;

    selected = scope.querySelector(selector);
    while (selected && selected !== scope) {
      amount = amountFromAttributes(selected) || parseEuroAmount(selected.textContent);
      if (amount) return amount;
      selected = selected.parentElement;
    }

    return null;
  }

  function visiblePriceAmount(scope) {
    var selectors = [
      '[data-offer-price-display]',
      '[data-product-price]',
      '.nevex-balance-product__price',
      '.nevex-product-ecosystem__card-price',
      '.nevex-product-ecosystem__price',
      '.price-item--regular',
      '.price-item',
      '.price'
    ].join(',');
    var price;
    var amount;

    price = scope ? scope.querySelector(selectors) : null;
    amount = price ? parseEuroAmount(price.textContent) : null;
    if (amount) return amount;

    price = document.querySelector('[data-product-price], .price-item--regular, .price-item, .price');
    return price ? parseEuroAmount(price.textContent) : null;
  }

  function findPrice(button) {
    var scope = button.closest('[data-nevex-balance-product], product-form, form, article, section, .product, .product-form, .shopify-section') || document;
    return selectedOfferAmount(scope) || visiblePriceAmount(scope);
  }

  function clearReferences() {
    document.querySelectorAll('.nevex-bgn-reference').forEach(function (item) {
      item.remove();
    });
  }

  function render() {
    var selectors = [
      'button[name="add"]',
      '.product-form__submit',
      '.sticky-atc-button',
      '.nevex-balance-product__start',
      '.nevex-product-ecosystem__form .nevex-product-ecosystem__link-button'
    ].join(',');

    suppressObserver = true;
    clearReferences();

    if (!isBulgarian()) {
      window.setTimeout(function () { suppressObserver = false; }, 120);
      return;
    }

    document.querySelectorAll(selectors).forEach(function (button) {
      var amount;
      var reference;

      if (button.disabled) return;

      amount = findPrice(button);
      if (!amount) return;

      reference = document.createElement('span');
      reference.className = 'nevex-bgn-reference';
      reference.textContent = '≈ ' + formatLev(amount * BGN_RATE);
      button.appendChild(reference);
    });

    window.setTimeout(function () { suppressObserver = false; }, 120);
  }

  function scheduleRender() {
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(render, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  ['change', 'input', 'click', 'variant:change'].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleRender, true);
  });

  new MutationObserver(function () {
    if (!suppressObserver) scheduleRender();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked', 'checked', 'data-offer-price', 'data-price']
  });
})();
